module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    class: _vm.buttonClass,
    attrs: {
      "type": "button",
      "title": _vm.title,
      "aria-label": _vm.title,
      "data-container": "body",
      "data-placement": "top",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('i', {
    class: _vm.iconClass,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading-icon') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06d5852e"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-06d5852e"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue
// module chunks = commit_pipelines pipelines